<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-10 17:24:46
 * @LastEditTime: 2021-08-12 14:19:54
 * @Description: 材料成本
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\statisticalAnalysis\materialCost\index.vue
 -->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialCost">
            <van-nav-bar
                title="材料成本"
                left-text="统计分析"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <div class="top-wrapper">
                <div class="select-wrapper">
                    <div class="select-item">
                        <div @click="showTimePicker(0)">
                            <span>{{ startTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                        <div @click="showTimePicker(1)">
                            <span>{{ endTimeValue }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                    </div>
                    <div
                        class="select-item"
                        @click="showStation = true"
                    >
                        <span>{{ stationName }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
            </div>
            <section class="van-pull-refresh">
                <div class="costInfo">
                    <div class="list">
                        <div>
                            <h4>{{ totalData.volume || 0 }}</h4>
                            <p>总产量(方)</p>
                        </div>
                        <div>
                            <h4>{{ totalData.all_cost || 0 }}</h4>
                            <p>总材料成本<br>(实际)</p>
                        </div>
                        <div>
                            <h4>{{ totalData.unit_cost || 0 }}</h4>
                            <p>单方材料成本<br>(实际)</p>
                        </div>
                    </div>
                    <div class="list">
                        <div>
                            <h4>{{ totalData.unit_price || 0 }}</h4>
                            <p>平均售价</p>
                        </div>
                        <div>
                            <h4>{{ totalData.b4f4 || 0 }}</h4>
                            <p>总材料成本<br>(平均)</p>
                        </div>
                        <div>
                            <h4>{{ totalData.b_unit_cost || 0 }}</h4>
                            <p>单方材料成本<br>(平均)</p>
                        </div>
                    </div>
                    <div class="list">
                        <div>
                            <h4>{{ totalData.d4f4 || 0 }}</h4>
                            <p>单方差价</p>
                        </div>
                        <div>
                            <h4>{{ totalData.c4e4 || 0 }}</h4>
                            <p>总成本差价</p>
                        </div>
                    </div>
                    <div class="list">
                        <div>
                            <h4>{{ totalData.h4d4 || 0 }}</h4>
                            <p>单方毛利</p>
                        </div>
                        <div>
                            <h4>{{ totalData.b4h4c4 || 0 }}</h4>
                            <p>总毛利</p>
                        </div>
                    </div>
                </div>
                <div class="SummaryTable">
                    <h4>原材成本汇总表</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>砼标号/特性</th>
                                <th>产量</th>
                                <th>总材料<br>成本(实际)</th>
                                <th>单方材料<br>成本(实际)</th>
                                <th>详细</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in pageData">
                                <tr :key="`cost_${index}`">
                                    <td>{{ item.NAMES }}</td>
                                    <td>{{ item.volume }}</td>
                                    <td>{{ item.all_cost }}</td>
                                    <td>{{ item.unit_cost }}</td>
                                    <td @click="viewDetails(item)">
                                        <i class="iconfont iconfanhui1"></i>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <!-- 选择场站 -->
                <van-popup
                    v-model="showStation"
                    position="bottom"
                >
                    <van-picker
                        show-toolbar
                        :columns="stationList"
                        value-key="name"
                        @cancel="showStation = false"
                        @confirm="onConfirm"
                    ></van-picker>
                </van-popup>
                <!-- 选择时间-->
                <van-popup
                    v-model="timePicker"
                    position="bottom"
                    :overlay="true"
                >
                    <van-datetime-picker
                        v-model="timeDate"
                        type="date"
                        title="选择年月日"
                        @confirm="confirmDate"
                        @cancel="timePicker = false"
                    ></van-datetime-picker>
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>
<script>
import utils from '@/assets/js/utils';

export default {
    name: 'material-cost',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/statisticalAnalysis') {
            this.$store.commit('noKeepAlive', 'material-cost');
        }
        next();
    },
    data() {
        return {
            // 选择场站
            showStation: false,
            // 时间控件
            timePicker: false,
            // 选择时间类型
            timeType: 0,
            // 时间控件初始化时间
            timeDate: '',
            // 开始时间
            startTimeValue: '',
            // 结束时间
            endTimeValue: '',
            // 选中场站id
            stationId: '',
            // 选中场站名称
            stationName: '全部',
            // 场站数据集
            stationList: [{
                station_id: '',
                name: '全部',
            }],
            // 页面数据
            pageData: [],
            // 合计数据
            totalData: {},
        };
    },
    computed: {},
    watch: {
        pageData(newVal) {
            if (newVal.length > 0) {
                if (newVal[0].NAMES === '合计') {
                    this.totalData = JSON.parse(JSON.stringify(newVal[0]));
                    newVal.splice(0, 1);
                }
            } else {
                this.totalData = {};
            }
        },
    },
    async created() {
        this.$toast.loading();
        const date = new Date();
        this.startTimeValue = utils.timeFormat(new Date(date.getFullYear(), date.getMonth()), 'yyyy-MM-dd');
        this.endTimeValue = utils.currentTimeFormat('yyyy-MM-dd');

        let stationIds = this.$takeTokenParameters('StationIds');
        if (stationIds) {
            stationIds = stationIds.split(',');
            const stationNames = this.$takeTokenParameters('StationNames').split(',');
            const stationList = stationIds.map((id, index) => {
                return {
                    station_id: id,
                    name: stationNames[index],
                };
            });
            this.stationList.push(...stationList);
        }
        this.pageData = await this.getPageData();
        this.$toast.clear();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 显示时间控件
        showTimePicker(num) {
            if (num === 0) {
                this.timeDate = new Date(this.startTimeValue);
            } else {
                this.timeDate = new Date(this.endTimeValue);
            }
            this.timeType = num;
            this.timePicker = true;
        },
        // 确认时间
        async confirmDate(date) {
            this.$toast.loading();
            if (this.timeType === 0) {
                this.startTimeValue = utils.timeFormat(date, 'yyyy-MM-dd');
            } else {
                this.endTimeValue = utils.timeFormat(date, 'yyyy-MM-dd');
            }
            this.timePicker = false;
            this.pageData = await this.getPageData();
            this.$toast.clear();
        },

        // 场站确认选择
        async onConfirm(item) {
            this.$toast.loading();
            this.stationId = item.station_id;
            this.stationName = item.name;
            this.showStation = false;
            this.pageData = await this.getPageData();
            this.$toast.clear();
        },

        // 查看材料成本详情
        viewDetails(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'materialCostDetails',
                params: {
                    item: item,
                },
            });
        },

        // 获取当前页面数据
        getPageData() {
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/report/yclxh/get_material_costcolor?beginTime=${this.startTimeValue}&endTime=${this.endTimeValue}&station_id=${this.stationId}`, { defEx: true });
        },

    },
};
</script>
<style lang="stylus" scoped>
.materialCost
    height 100%
    .top-wrapper
        background #ffffff
        padding 14rpx
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    line-height 45rpx
                i
                    color #979EA7
                &:last-child
                    span
                        color #3495FB
                        padding-left 20rpx
                        border-left 2rpx solid #D7D7D7
                &:first-child
                    flex 2
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 600
    section
        padding-bottom 15rpx
        height calc(100% - 110rpx)
        -webkit-overflow-scrolling touch
        overflow scroll
        .costInfo
            padding 0 13rpx
            .list
                display flex
                &:nth-of-type(1)
                    div
                        background rgba(85, 136, 241, 0.06)
                        h4
                            color #5588F1
                        &:nth-of-type(2)
                            background #FFF8F3
                            h4
                                color #FA8639
                        &:nth-of-type(3)
                            background #FFF8F3
                            h4
                                color #FA8639
                &:nth-of-type(2)
                    div
                        background rgba(33, 189, 204, 0.06)
                        h4
                            color #21BDCC
                &:nth-of-type(3)
                    div
                        background rgba(255, 175, 17, 0.06)
                        h4
                            color #FFAF11
                &:nth-of-type(4)
                    div
                        background rgba(17, 187, 254, 0.06)
                        h4
                            color #11BBFE
                div
                    flex 1
                    padding 10rpx 15rpx
                    border 1px solid #fff
                    h4
                        font-size 16rpx
                        font-weight 600
                    p
                        font-size 12rpx
                        color #666666
        .SummaryTable
            h4
                font-size 16rox
                color #333333
                line-height 36rpx
                padding 0 14rpx
            table
                width 100%
                padding 0 12rpx
                th,td
                    font-size 12rpx
                thead
                    th
                        height 40rpx
                        border 1px solid #DEE3EF
                        background #EBF0FC
                        color #333333
                tbody
                    td
                        color #0091FF
                        height 32rpx
                        padding 0 5rpx
                        text-align center
                        background rgba(85, 136, 241, 0.04)
                        &:nth-of-type(1)
                            border 1px solid #DEE3EF
                            background #F5F2ED
                            color #823802
                            width 90rpx
                        &:nth-of-type(5)
                            border 1px solid #E3EBFF
                            background rgba(85, 136, 241, 0.04)
                            color #979EA7
                            width 37rpx
</style>
